export const getSignFormSubmitButtonTitle = (addDataDetail) =>{
  if(addDataDetail?.pageName === 'item_reports' && addDataDetail?.parentPageName === 'approve_jobs'){
    return "Send Report"
  }else{
    return 'Save & Close'
  }
}